import { Repository } from './repository'

class RunRepository extends Repository {
  URL = 'results/runs/'
}

class ResultRepository extends Repository {
  constructor(runId) {
    super()
    this.URL = `results/runs/${runId}/results/`
  }
}

export { RunRepository, ResultRepository }
